// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOG_REPORT_ARTICLE = "Nahl\u00e1sit \u010dl\u00e1nek";
export const CHANGE_ARTICLE = "Zm\u011b\u0148 \u010dl\u00e1nek";
export const DELETE_ARTICLE = "Vyma\u017e \u010dl\u00e1nek";
export const REMOVE_FROM_FEED = "Odstranit z feedu";
export const RETURN_TO_FEED = "Vr\u00e1tit do feedu";
export const SEO_TITLE_BLOGS_article = "%(article)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017eivatelky, kter\u00fdm se to l\u00edb\u00ed";
